'use client';

import { useEffect } from 'react';

import styles from '../contact-page.module.css';

// Same public sales agent configured in the main website checkout.
const salesAgentId =
  process.env.NEXT_PUBLIC_LEAGENAI_SALES_AGENT_ID ||
  'a6dd9ac1-6289-461f-a234-243b640a9eda';

export function ContactNexusLauncher() {
  useEffect(() => {
    if (document.querySelector('script[src*="leagen-chatbot.js"]')) return;
    const script = document.createElement('script');
    script.src = 'https://www.leagen.co/dist/leagen-chatbot.js';
    script.dataset.agentId = salesAgentId;
    script.dataset.defaultAgentId = salesAgentId;
    script.defer = true;
    document.body.appendChild(script);
  }, []);
  return (
    <div
      className={styles.nexusScene}
      aria-label="Chat with the Leagen sales agent"
    >
      <leagen-launcher
        agent-id={salesAgentId}
        style-variant="agent_avatar"
        callout-text="Chat with us"
        callout-position="below"
        callout-behavior="persist"
      />
    </div>
  );
}
